<template>
    <a-modal :width="1200"
             title="购标详情"
             :visible="visible"
             :maskClosable="false"
             @cancel="$emit('cancel')"
    >
        <template slot="footer">
            <!--            <a-button type="primary" @click="onDel()" v-show="packSupplierModel.systemType==='1'">删除</a-button>-->
            <a-button type="primary" @click.stop="closeWin()">关闭</a-button>
        </template>
        <a-card class="card">
            <table class="fx-form-view">
                <tr>
                    <th>供应商名称</th>
                    <td>{{packSupplierModel.supplierName}}</td>
                    <th>{{packSupplierModel.supplierType==='1'?'身份证号码':'社会统一信用代码'}}</th>
                    <td>
                        {{packSupplierModel.supplierCode}}
                    </td>
                </tr>
                <tr>
                    <th>联系人</th>
                    <td>{{packSupplierModel.contacts}}</td>
                    <th>联系人手机号</th>
                    <td>{{packSupplierModel.mobile}}</td>
                </tr>
                <tr>
                    <th>电子邮件</th>
                    <td>{{packSupplierModel.supplierEmail}}</td>
                    <th>办公电话</th>
                    <td>{{packSupplierModel.telephone}}</td>
                </tr>
                <tr>
                    <th>保证金账号</th>
                    <td colspan="3" v-if="packSupplierModel.isPay==='1'">{{packSupplierModel.qybzjxnzh ===
                        '1'?packSupplierModel.mergeAccno:'不使用农行账号'}}
                    </td>
                    <td colspan="3" v-else>无需缴纳保证金</td>
                </tr>
              <invoice-attend-modal-tr :order-id="this.orderId"/>
            </table>
            <a-divider v-if="packSupplierModel.isPay==='1' && packSupplierModel.qybzjxnzh === '1'" class="color-orange"
                       orientation="left">保证金缴退信息
            </a-divider>

            <s-table v-if="packSupplierModel.isPay==='1' && packSupplierModel.qybzjxnzh === '1'"
                     ref="table"
                     :columns="columns"
                     :rowKey="record => record.logNo"
                     :data="loadData"
                     :pagination="{ showTotal: total => `总共 ${total} 条`,pageSizeOptions:pageSizeOptions }"
                     size="middle"
                     class="border"
                     :pageSize="pageSize"
            >
                <span slot="amount" slot-scope="text,record"><p :style="record.amount<0?'color: red':'color: green'">{{record.amount}}</p></span>
                <span slot="tradeTime" slot-scope="text,record">{{record.tradeTime|formatData}}</span>
                <span slot="action" slot-scope="text,record"><a-button class="ml-1 mr-1" type="primary"
                                                                       v-if="record.amount>0 && canSee && record.refundMark==='N'"
                                                                       @click="refund(record)">退款</a-button>
                <a-button class="ml-1 mr-1" type="primary"
                          v-if="record.amount>0 && canSee && record.refundMark==='Y'"
                          >已退款</a-button>
                </span>

            </s-table>
        </a-card>
    </a-modal>
</template>

<script>
  import qs from 'qs'
  import STable from '@/components/Table'
  import { PageView } from '@/layouts'
  import InvoiceAttendModalTr from '@/views/bid/cwgl/InvoiceAttendModalTr'

  export default {
    name: 'anntedInfo',
    props: ['visible', 'orderId'],
    components: {
      InvoiceAttendModalTr,
      PageView,
      STable
    },
    created () {
    },
    filters: {
      formatData: function (val) {
        if (val) {
          return val.substring(0, 4) + '-' + val.substring(4, 6) + '-' + val.substring(6, 8)
        }
      }
    },
    data () {
      return {
        canSee:false,
        packSupplierModel: {},
        pageSizeOptions: ['5', '8', '10'],
        columns: [
          {
            title: '交易时间',
            width: '100px',
            scopedSlots: { customRender: 'tradeTime' }
          },
          {
            title: '银行日志号',
            width: '120px',
            dataIndex: 'logNo',
            scopedSlots: { customRender: 'logNo' }
          },
          {
            title: '对方账户名',
            width: '120px',
            dataIndex: 'oppositeAccountName',
            scopedSlots: { customRender: 'oppositeAccountName' }
          },
          {
            title: '对方账号',
            width: '120px',
            dataIndex: 'oppositeAccount',
            scopedSlots: { customRender: 'oppositeAccount' }
          },
          {
            title: '对方银行',
            width: '120px',
            dataIndex: 'oppositeHM',
            scopedSlots: { customRender: 'oppositeHM' }
          },
          {
            title: '交易金额',
            width: '80px',
            scopedSlots: { customRender: 'amount' }
          },
          {
            title: '余额',
            width: '80px',
            dataIndex: 'balance',
            scopedSlots: { customRender: 'balance' }
          },
          {
            title: '上笔余额',
            width: '80px',
            dataIndex: 'lastBalance',
            scopedSlots: { customRender: 'lastBalance' }
          },
          {
            title: '附言',
            width: '150px',
            dataIndex: 'remark',
            scopedSlots: { customRender: 'remark' }
          }
          , {
            title: '操作',
            width: '60px',
            scopedSlots: { customRender: 'action' }
          }

        ],
        pageSize: 5,
        queryParam: {
          bankAccount: '',
          accountBookNo: ''
        },
        loadData: parameter => {
          return this.$http.get('/api/1/bond/getBondDetails.json', {
            params: Object.assign(parameter, this.queryParam),
            paramsSerializer: function (params) {
              return qs.stringify(params, { indices: false })
            }
          }).then(res => {
            console.log(res)
            return res.result
          })
        },
      }
    },
    methods: {
      refund (record) {
        let that = this
        let data = record
        data.bondId =  that.packSupplierModel.bondId
        data.amount = record.amount
        data.recordId =  record.recordId //明细id
        that.$http.post('/api/1/bond/refund.json', qs.stringify(data)).then(function (response) {
          if (response.code === 200) {
            that.$refs.table.refresh()
            that.$message.success('退款成功')
          }

        })
      },
      onDel () {
        const that = this
        let message = '该供应商为网上购标供应商，不允许删除！'
        if (that.packSupplierModel.signType === '2') {
          that.$http.get('/api/1/bidReceive/ExistSuppler/' + that.packSupplierModel.id + '/' + that.packSupplierModel.packId).then(function (response) {
            if (200 !== response.code) {
              return
            }
            if (response.result) {
              message = '项目已经开标，不允许删除！'
            } else {
              message = '您正在删除购标供应商，请确认是否继续？！'
            }
            that.onConfirm(message, response.result)
          })
        } else {
          that.onConfirm(message, false)
        }
      },
      onConfirm (conten, isHas) {
        let that = this
        that.$confirm({
          title: '请确认',
          content: conten,
          onOk: () => {
            if (!isHas && that.packSupplierModel.signType === '2') {
              that.$http.get('/api/1/signSupplier/delAttend.json?id=' + that.packSupplierModel.id).then(function (response) {
                if (200 !== response.code) {
                  that.$message.error('删除失败')
                  return
                }
                that.$message.success('删除成功')
                that.$emit('success', '1')
              })
            }
            console.log('您点击了确定！')
          },
          onCancel: () => {
            console.log('您点击了取消！')
          }
        })
      },
      packSupplier (attendId, isPay, qybzjxnzh,canSee) {
        const that = this
        that.canSee = canSee
        if (!attendId) {
          that.$message.warning('参数错误，无法查看信息')
          return
        }
        that.queryParam = {
          bankAccount: '',
          accountBookNo: ''
        }
        that.packSupplierModel = []
        that.$http.get('/api/1/signSupplier/getPackSupplierInfo.json?attendId=' + attendId).then((response)=> {
          const result = response.result
          console.log(result)
          that.packSupplierModel = result
          that.packSupplierModel.isPay = isPay
          that.packSupplierModel.qybzjxnzh = qybzjxnzh
          if (result.bankAccount) {
            that.queryParam.bankAccount = result.bankAccount
            that.queryParam.accountBookNo = result.accountBookNo
            if (that.$refs.table) {
              that.$refs.table.refresh()
            }

          }
        })
      },

      packSupplier2 (bzid, xydm, isPay, qybzjxnzh) {
        const that = this
        that.queryParam = {
          bankAccount: '',
          accountBookNo: ''
        }
        that.packSupplierModel = []
        that.$http.get('/api/1/signSupplier/getPackSupplierInfo2.json?bzid=' + bzid + '&xydm=' + xydm).then(function (response) {
          const result = response.result
          that.packSupplierModel = result
          console.log(that.packSupplierModel)
          console.log('that.packSupplierModel')
          that.packSupplierModel.isPay = isPay
          that.packSupplierModel.qybzjxnzh = qybzjxnzh
          if (result.bankAccount) {
            that.queryParam.bankAccount = result.bankAccount
            that.queryParam.accountBookNo = result.accountBookNo
            if (that.$refs.table) {
              that.$refs.table.refresh()
            }
          }
        })
      },

      closeWin () {
        let that = this
        that.$emit('success')
      },
    }
  }

</script>
<style lang="less" scoped>
    .card {
        margin-bottom: 14px;
    }

    .fx-form-view th {
        width: 140px;
    }

    .amount {
        color: red;
        font-size: 22px;
    }
</style>
